// frontend/src/pages/ProductDetailPage.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Heart, Share2, ShoppingCart, Truck, Shield, RotateCcw,
  Star, Minus, Plus, ChevronRight, Phone, Send, MessageCircle
} from 'lucide-react';
import { useProduct } from '../hooks/useProducts';
import { useCart } from '../hooks/useCart';
import { Loading } from '../components/UI/Loading';
import { toast } from 'react-hot-toast';
import { PageSEO } from '../components/SEO/PageSEO';
import api from '../services/api';
import config from '../config';
import ProductSchema from '../components/SEO/ProductSchema';

// ============================================================
// آیکون‌های پیام‌رسان‌ها
// ============================================================

const MessengerIcon = ({ type, className = "w-5 h-5" }) => {
  switch (type) {
    case 'telegram':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
        </svg>
      );
    case 'soroush':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
          <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
        </svg>
      );
    case 'bale':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
          <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6z" />
        </svg>
      );
    case 'eitaa':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
        </svg>
      );
    case 'rubika':
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
        </svg>
      );
    case 'whatsapp':
    default:
      return (
        <svg className={className} viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      );
  }
};

// ============================================================
// تابع دریافت لینک پیام‌رسان
// ============================================================

const getMessengerLink = (type, phone, username, link) => {
  // اگر لینک مستقیم وجود دارد
  if (link) return link;

  const cleanPhone = phone?.replace(/^0/, '').replace(/[^0-9]/g, '') || '';

  switch (type) {
    case 'whatsapp':
      return `https://wa.me/98${cleanPhone}`;
    case 'telegram':
      return username ? `https://t.me/${username}` : `https://t.me/${cleanPhone}`;
    case 'soroush':
      return `https://sapp.ir/${username || cleanPhone}`;
    case 'bale':
      return `https://bale.ai/${username || cleanPhone}`;
    case 'eitaa':
      return `https://eitaa.com/${username || cleanPhone}`;
    case 'rubika':
      return `https://rubika.ir/${username || cleanPhone}`;
    default:
      return `tel:${phone}`;
  }
};

// ============================================================
// کامپوننت اصلی
// ============================================================

export const ProductDetailPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { data: product, isLoading } = useProduct(slug);
  const { addToCart, isInCart } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [siteSettings, setSiteSettings] = useState(null);

  // دریافت تنظیمات سایت
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get('/cms/settings/get_settings/');
        setSiteSettings(response.data);
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };
    fetchSettings();
  }, []);

  // دریافت محصولات مرتبط
  useEffect(() => {
    if (product?.data?.category?.id) {
      const fetchRelated = async () => {
        try {
          const response = await api.get(`/products/products/?category=${product.data.category.slug}&limit=4`);
          const filtered = response.data.results?.filter(p => p.slug !== slug) || [];
          setRelatedProducts(filtered.slice(0, 4));
        } catch (error) {
          console.error('Error fetching related products:', error);
        }
      };
      fetchRelated();
    }
  }, [product?.data?.category?.id, slug]);

  const formatPrice = (price) => {
    if (price === undefined || price === null) return '۰';
    let numPrice;
    if (typeof price === 'string') {
      numPrice = parseFloat(price);
    } else if (typeof price === 'number') {
      numPrice = price;
    } else if (price && typeof price === 'object') {
      numPrice = parseFloat(price.toString());
    } else {
      numPrice = Number(price);
    }
    if (isNaN(numPrice)) return '۰';
    return numPrice.toLocaleString('fa-IR');
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading size="lg" />
      </div>
    );
  }

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">محصول یافت نشد</h2>
          <p className="text-gray-600">محصول مورد نظر شما وجود ندارد یا حذف شده است</p>
          <button onClick={() => navigate('/products')} className="mt-4 text-blue-600 hover:underline">
            بازگشت به محصولات
          </button>
        </div>
      </div>
    );
  }

  const productData = product.data || product;
  const settings = siteSettings || {};

  const handleAddToCart = () => {
    addToCart(productData, quantity);
    toast.success('محصول به سبد خرید اضافه شد');
  };

  const handleBuyNow = () => {
    addToCart(productData, quantity);
    navigate('/cart');
  };

  const handlePriceOnCall = () => {
    const phoneNumber = productData.contact_phone || settings.contact_phone || config.CONTACT_PHONE || '021-88315658';
    window.location.href = `tel:${phoneNumber}`;
  };

  const handleMessenger = () => {
    const messengerType = settings.messenger_type || 'whatsapp';
    const phone = settings.messenger_phone || settings.contact_phone || config.CONTACT_WHATSAPP || '';
    const username = settings.messenger_username || '';
    const link = settings.messenger_link || '';

    const messengerLink = getMessengerLink(messengerType, phone, username, link);
    window.open(messengerLink, '_blank');
  };

  const images = productData.images?.length > 0
    ? productData.images
    : [{ image: productData.main_image || '/placeholder-product.jpg' }];

  const seoTitle = productData.meta_title || productData.name;
  const seoDescription = productData.meta_description || productData.description?.substring(0, 160);
  const seoKeywords = productData.meta_keywords;
  const seoImage = productData.main_image || images[0]?.image;

  // تنظیمات پیام‌رسان
  const messengerType = settings.messenger_type || 'whatsapp';
  const showMessenger = settings.show_messenger_button !== false;
  const messengerButtonText = settings.messenger_button_text || 'ارسال پیام';

  // نام‌های پیام‌رسان‌ها برای نمایش
  const messengerNames = {
    'whatsapp': 'واتساپ',
    'telegram': 'تلگرام',
    'soroush': 'سروش',
    'bale': 'بله',
    'eitaa': 'ایتا',
    'rubika': 'روبیکا',
    'phone_only': 'تماس تلفنی'
  };
  const messengerDisplayName = messengerNames[messengerType] || 'پیام‌رسان';

  return (
    <>
      <PageSEO
        title={seoTitle}
        description={seoDescription}
        keywords={seoKeywords}
        image={seoImage}
        type="product"
      />
      {/* ====== Product Schema برای گوگل ====== */}
      <ProductSchema product={productData} />
      {/* ====== محتوای اصلی صفحه ====== */}

      <div className="min-h-screen bg-gray-50 py-8">
        <div className="container mx-auto px-4 max-w-6xl">
          {/* مسیر راهنما */}
          <div className="flex items-center gap-2 text-sm text-gray-500 mb-6 flex-wrap">
            <button onClick={() => navigate('/')} className="hover:text-blue-600">خانه</button>
            <ChevronRight className="w-4 h-4" />
            <button onClick={() => navigate('/products')} className="hover:text-blue-600">محصولات</button>
            <ChevronRight className="w-4 h-4" />
            <span className="text-gray-900 font-medium">{productData.name}</span>
          </div>

          <div className="bg-white rounded-2xl shadow-sm overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-6 lg:p-8">
              {/* Images */}
              <div className="space-y-4">
                <div className="aspect-square bg-gray-100 rounded-xl overflow-hidden">
                  <img
                    src={images[selectedImage]?.image}
                    alt={productData.name}  // ✅ alt اضافه شد
                    title={productData.name}  // ✅ title اضافه شد
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                {images.length > 1 && (
                  <div className="flex gap-2 overflow-x-auto pb-2">
                    {images.map((img, index) => (
                      <button
                        key={index}
                        onClick={() => setSelectedImage(index)}
                        className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 ${selectedImage === index ? 'border-blue-600' : 'border-transparent'}`}
                      >
                        <img
                          src={img.image}
                          alt={`${productData.name} - تصویر ${index + 1}`}  // ✅ alt اضافه شد
                          title={`${productData.name} - تصویر ${index + 1}`}  // ✅ title اضافه شد
                          className="w-full h-full object-cover"
                        />
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Info */}
              <div className="space-y-6">
                <div>
                  <h1 className="text-2xl lg:text-3xl font-bold text-gray-900">{productData.name}</h1>
                  <div className="flex items-center gap-4 mt-2 flex-wrap">
                    <div className="flex items-center gap-1">
                      <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                      <span className="font-bold">{productData.average_rating || '۴.۵'}</span>
                      <span className="text-gray-500 text-sm">({productData.review_count || 0} نظر)</span>
                    </div>
                    <span className="text-gray-300">|</span>
                    <span className="text-blue-600 font-medium">{productData.category?.name}</span>
                    {productData.brand && (
                      <>
                        <span className="text-gray-300">|</span>
                        <span className="text-gray-600">برند: {productData.brand}</span>
                      </>
                    )}
                  </div>
                </div>

                <div className="border-t border-b border-gray-100 py-6">
                  {productData.show_price_on_call === true ? (
                    // ============================================================
                    // ✅ حالت "تماس برای قیمت" - بدون دکمه‌های خرید
                    // ============================================================
                    <div className="flex flex-col gap-4">
                      {/* هدر */}
                      <div className="flex items-center gap-3 bg-green-50 p-4 rounded-lg border border-green-200">
                        <Phone className="w-6 h-6 text-green-600 flex-shrink-0" />
                        <div>
                          <span className="text-lg font-bold text-gray-800">تماس برای قیمت</span>
                          <p className="text-sm text-gray-600">برای استعلام قیمت این محصول با ما تماس بگیرید</p>
                        </div>
                      </div>

                      {/* دکمه‌های تماس */}
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <button
                          onClick={handlePriceOnCall}
                          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg flex items-center justify-center gap-2 text-lg transition-colors"
                        >
                          <Phone className="w-5 h-5" />
                          تماس تلفنی
                        </button>

                        {/* ✅ دکمه پیام‌رسان با تنظیمات ادمین */}
                        {showMessenger && messengerType !== 'phone_only' && (
                          <button
                            onClick={handleMessenger}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg flex items-center justify-center gap-2 text-lg transition-colors"
                          >
                            <MessengerIcon type={messengerType} className="w-5 h-5" />
                            {messengerButtonText || messengerDisplayName}
                          </button>
                        )}
                      </div>

                      {/* شماره تماس */}
                      <div className="text-center p-3 bg-gray-50 rounded-lg">
                        <p className="text-sm text-gray-600">
                          شماره تماس:
                          <span className="font-bold text-gray-800 mr-2">
                            {productData.contact_phone || settings.contact_phone || config.CONTACT_PHONE || '021-88315658'}
                          </span>
                        </p>
                        <p className="text-xs text-gray-400 mt-1">
                          پاسخگویی: شنبه تا پنجشنبه ۹ الی ۱۸
                        </p>
                      </div>

                      {/* ❌ دکمه‌های خرید در این حالت نمایش داده نمی‌شوند */}
                    </div>
                  ) : (
                    // ============================================================
                    // ✅ حالت نمایش قیمت عادی - با دکمه‌های خرید
                    // ============================================================
                    <>
                      {/* نمایش قیمت */}
                      <div className="flex items-baseline gap-3 flex-wrap">
                        {productData.discount_price && (
                          <span className="text-2xl text-gray-400 line-through">
                            {formatPrice(productData.price)} تومان
                          </span>
                        )}
                        <span className="text-3xl font-bold text-blue-700">
                          {formatPrice(productData.final_price || productData.price)} تومان
                        </span>
                        {productData.discount_percent > 0 && (
                          <span className="inline-block bg-red-500 text-white text-sm px-2 py-1 rounded">
                            {productData.discount_percent}% تخفیف
                          </span>
                        )}
                        {productData.stock > 0 ? (
                          <span className="inline-block bg-green-500 text-white text-sm px-2 py-1 rounded">
                            موجود در انبار
                          </span>
                        ) : (
                          <span className="inline-block bg-red-500 text-white text-sm px-2 py-1 rounded">
                            ناموجود
                          </span>
                        )}
                      </div>

                      {/* دکمه‌های خرید - فقط در حالت عادی */}
                      <div className="space-y-4 mt-4">
                        {/* انتخاب تعداد */}
                        <div className="flex items-center gap-4">
                          <span className="text-gray-700 font-medium">تعداد:</span>
                          <div className="flex items-center border border-gray-300 rounded-lg">
                            <button
                              onClick={() => setQuantity(Math.max(1, quantity - 1))}
                              className="p-2 hover:bg-gray-100"
                              disabled={productData.stock === 0}
                            >
                              <Minus className="w-4 h-4" />
                            </button>
                            <span className="w-12 text-center font-medium">{quantity}</span>
                            <button
                              onClick={() => setQuantity(Math.min(productData.stock || 999, quantity + 1))}
                              className="p-2 hover:bg-gray-100"
                              disabled={productData.stock === 0}
                            >
                              <Plus className="w-4 h-4" />
                            </button>
                          </div>
                          {productData.stock > 0 && productData.stock < 10 && (
                            <span className="text-sm text-orange-600">تنها {productData.stock} عدد باقی مانده</span>
                          )}
                        </div>

                        {/* دکمه‌های خرید */}
                        <div className="flex flex-col sm:flex-row gap-3">
                          <button
                            onClick={handleAddToCart}
                            disabled={productData.stock === 0}
                            className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-white font-bold py-3 px-6 rounded-lg flex items-center justify-center gap-2 transition-colors"
                          >
                            <ShoppingCart className="w-5 h-5" />
                            {isInCart(productData.id) ? 'به روزرسانی سبد' : 'افزودن به سبد'}
                          </button>
                          <button
                            onClick={handleBuyNow}
                            disabled={productData.stock === 0}
                            className="flex-1 bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white font-bold py-3 px-6 rounded-lg transition-colors"
                          >
                            خرید فوری
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* ویژگی‌های محصول - در هر دو حالت نمایش داده می‌شود */}
                <div className="grid grid-cols-3 gap-4 text-center text-sm">
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <Truck className="w-6 h-6 mx-auto mb-2 text-blue-600" />
                    <span className="text-gray-600">ارسال سریع</span>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <Shield className="w-6 h-6 mx-auto mb-2 text-blue-600" />
                    <span className="text-gray-600">ضمانت اصالت</span>
                  </div>
                  <div className="p-4 bg-gray-50 rounded-lg">
                    <RotateCcw className="w-6 h-6 mx-auto mb-2 text-blue-600" />
                    <span className="text-gray-600">۷ روز ضمانت بازگشت</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Description */}
            <div className="border-t border-gray-100 p-6 lg:p-8">
              <h2 className="text-xl font-bold text-gray-900 mb-4">توضیحات محصول</h2>
              <div className="prose max-w-none text-gray-600 leading-relaxed whitespace-pre-wrap">
                {productData.description}
              </div>

              {productData.specifications && Object.keys(productData.specifications).length > 0 && (
                <div className="mt-8">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">مشخصات فنی</h3>
                  <div className="bg-gray-50 rounded-lg overflow-hidden">
                    {Object.entries(productData.specifications).map(([key, value], index) => (
                      <div
                        key={key}
                        className={`flex justify-between p-4 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                      >
                        <span className="text-gray-600 font-medium">{key}</span>
                        <span className="text-gray-900">{String(value)}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* محصولات مرتبط */}
          {relatedProducts.length > 0 && (
            <div className="mt-12">
              <h2 className="text-xl font-bold text-gray-900 mb-6">محصولات مرتبط</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                {relatedProducts.map((related) => (
                  <div
                    key={related.id}
                    onClick={() => navigate(`/products/${related.slug}`)}
                    className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition cursor-pointer"
                  >
                    <img
                      src={related.main_image || '/placeholder-product.jpg'}
                      alt={related.name}  // ✅ alt اضافه شد
                      title={related.name}  // ✅ title اضافه شد
                      className="w-full h-48 object-cover"
                      loading="lazy"
                    />
                    <div className="p-4">
                      <h3 className="font-bold text-gray-900 line-clamp-2">{related.name}</h3>
                      {related.show_price_on_call ? (
                        <p className="text-green-600 font-bold mt-2">تماس برای قیمت</p>
                      ) : (
                        <p className="text-blue-600 font-bold mt-2">{formatPrice(related.final_price || related.price)} تومان</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};